import { render, staticRenderFns } from "./tieba-float-panel-item-get.vue?vue&type=template&id=873c49ca&scoped=true&"
import script from "./tieba-float-panel-item-get.vue?vue&type=script&lang=js&"
export * from "./tieba-float-panel-item-get.vue?vue&type=script&lang=js&"
import style0 from "./tieba-float-panel-item-get.vue?vue&type=style&index=0&id=873c49ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873c49ca",
  null
  
)

export default component.exports